import httpClient from "./httpClient";

const AuditService = {
  async findAll(params = {}) {
    return await httpClient.get("/audit", { params });
  }
};

export default AuditService;
